module.exports = __webpack_public_path__ + "img/8-Guy_W_The_Cap LEFT.9e6d99a.png";